import { createSlice } from '@reduxjs/toolkit';
const categoryNavigationSlice = createSlice({
  name: 'categoryNavigation',
  initialState: {
    currentIndex: 0,
    fakeid:0,
    activecategory:"homepage",
    darkmode:null,
    activetab:'home',
    fontsize:null,
    loading:false,
    headerHeight:0,
    fooNavHeight:0,
  },
  reducers: {
    incrementCategory(state) {
      state.currentIndex =1;
      state.fakeid+=1;           
    },
    decrementCategory(state) {
      state.currentIndex = -1;
       state.fakeid -=1;
    },
     activeCategorySlice(state, action) {
      state.activecategory = action.payload;      
    },

    darkmodeslice (state,action){
      state.darkmode = action.payload;
    },

    activetabslice (state,action){
      state.activetab = action.payload;
  },
  fontsizeslice (state,action){
    state.fontsize = action.payload;
  },
  loadingRequestSlice (state,action){
    state.loading = action.payload;
  },
  loadingSuccessSlice (state,action){
    state.loading = action.payload;
  },
   setHeaderHeightSlice (state,action){
    state.headerHeight = action.payload;
  },
  setFooNavHeightSlice (state,action){
    state.fooNavHeight = action.payload;
  }
  },
});

export const { incrementCategory, decrementCategory,activeCategorySlice, darkmodeslice, activetabslice, fontsizeslice, loadingRequestSlice, loadingSuccessSlice, setHeaderHeightSlice, setFooNavHeightSlice } = categoryNavigationSlice.actions;
export default categoryNavigationSlice.reducer;